<template>
  <div>
    <h2 class="content-block">Practice Parent Child Template</h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        Put your content here
        <h1>{{ parentValue }}</h1>
        <ChildComponent :childProp="parentValue" />
      </div>
    </div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <div class="pies-container">
          <PieComponent
            :dsProp="getDs('pegawaiStatus')"
            :printHelper="printHelper"
            titleProp="Berdasarkan Status Pegawai"
            argumentFieldProp="nama"
          />
        </div>

        <div class="pies-container">
          <PieComponent
            :dsProp="getDs('jenisKelamin')"
            :printHelper="printHelper"
            titleProp="Berdasarkan Gender Pegawai"
            argumentFieldProp="jenis_kelamin"
          />
        </div>
        <div class="pies-container">
          <PieComponent
            :dsProp="getDs('cabang')"
            :printHelper="printHelper"
            titleProp="Berdasarkan Cabang"
            argumentFieldProp="nama"
          />
        </div>
        <div class="pies-container">
          <PieComponent
            :dsProp="getDs('golongan')"
            :printHelper="printHelper"
            titleProp="Berdasarkan Golongan"
            argumentFieldProp="nama"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import ChildComponent from "./ChildComponent.vue";
import PieComponent from "./PieComponent.vue";
import axios from "axios";
export default {
  components: {
    ChildComponent,
    PieComponent,
  },
  data() {
    return {
      parentValue: "Hello from parent!",
      dataSource: null,
    };
  },
  async mounted() {
    this.dataSource = await this.fetchDataMethod();
    console.log("dataSource", this.dataSource);
  },
  methods: {
    getDs(val) {
      if (this.dataSource) {
        console.log("getDs", this.dataSource[val]);
        return this.dataSource[val];
      }
    },
    printHelper(val) {
      console.log("printHelper", val);
    },
    async fetchDataMethod() {
      try {
        const response = await axios.get(
          "http://127.0.0.1/api/rangkuman_dashboard_chart"
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
  },
};
</script>
